import React from 'react';

import { GetPageCampaignIdsQuery } from '../../../types/__generated__';
import { useFlags } from '../../hooks/useFlags';
import useFullPageQuery from '../../hooks/useFullPageQuery';
import GetPageCampaignIds from './query.gql';
import Strava from './Strava';

const isInAllowedCampaigns = (
  enabledCampaignIds: string[] | '*',
  campaignIds: string[] = [],
) => {
  if (enabledCampaignIds === '*') {
    return true;
  }
  if (Array.isArray(enabledCampaignIds)) {
    return enabledCampaignIds.some(id => campaignIds.includes(id as string));
  }
  return false;
};

export function isStravaEnabled(
  { enableStrava, enabledStravaCampaignGUIDs }: StravaFlags,
  campaignIds?: string[],
) {
  return (
    enableStrava &&
    isInAllowedCampaigns(enabledStravaCampaignGUIDs, campaignIds)
  );
}

type StravaFlags = {
  enableStrava: boolean;
  enabledStravaCampaignGUIDs: '*' | string[];
};

export function useIsStravaEnabled() {
  const flags = useFlags<StravaFlags>();
  const { data } = useFullPageQuery<GetPageCampaignIdsQuery>(
    GetPageCampaignIds,
  );
  const campaignIds = data?.page?.relationships?.campaigns.nodes.map(
    n => n.legacyId,
  );
  return isStravaEnabled(flags, campaignIds);
}

export const StravaBehindFeatureFlag: React.FunctionComponent = () => {
  const isEnabled = useIsStravaEnabled();
  if (isEnabled) {
    return <Strava />;
  }
  return null;
};
